import React from 'react';
import {
    isLoadedPresentationProps,
    useGraphPresentationProps
} from './results-graph/use-graph-presentation-props';
import {GlobalVersionData} from '../../../../hooks/global-version/use-global-version-query';
import {MaxPathLengthOptionResult} from './results-graph/requests/use-query-result-max-length-options';
import {GraphPresentation} from './results-graph/interface';
import {CompletedQueryLoadedContent} from './completed-query-loaded-content';
import {QueryLayoutLoading} from '../query-layout-loading';
import {useSidebarTabs} from '../../../../hooks/use-sidebar-tabs';

export interface CompletedQueryInnerContentProps {
    selectedQuery: CompletedQuery;
    globalVersions: GlobalVersionData[];
    maxPathLengthOptions: MaxPathLengthOptionResult;
    presentations: GraphPresentation[];
    sidebarTabsProps: ReturnType<typeof useSidebarTabs>;
}

export const CompletedQueryContentWithPresentations = ({
    presentations,
    ...restProps
}: CompletedQueryInnerContentProps) => {
    const graphPresentationProps = useGraphPresentationProps(
        restProps.selectedQuery.id,
        presentations,
        restProps.maxPathLengthOptions
    );

    if (!isLoadedPresentationProps(graphPresentationProps)) {
        return <QueryLayoutLoading />;
    }

    return (
        <CompletedQueryLoadedContent
            {...restProps}
            graphPresentationProps={graphPresentationProps}
        />
    );
};
